import React from 'react';
import { Heading } from '@landr/maestro';
import { PricingProvider, Environment, Languages } from '@landr/pricing';
import { Edges, PageContextType } from 'types';
import { StaticQuery, graphql } from 'gatsby';
import { getTwoLetterLanguageCode } from 'helpers';
import { log } from '../../../log';
import { SliceContext } from '../types';
import { SupportedPrismicSlicesEnum } from '../enums';
import { PricingTabDocument, CommonPricingTranslations } from './types';
import { PricingTabs, Tabs } from './components/PricingTabs';
import { StyledPricingContentBox } from './styled';

const logger = log.getInstance('PricingTab');

export type PricingTableDocument = CommonPricingTranslations & {
    tabs: Tabs;
};

export type PricingSliceProps = {
    sliceContext: SliceContext;
    pageContext: PageContextType;
    location: Location;
    slice: {
        type: SupportedPrismicSlicesEnum.pricing;
        primary: {
            pricing_table: PricingTableDocument;
            pricing_title: string;
        };
    };
};

const PricingQuery = graphql`
    {
        allPrismicPricingTabsJson {
            edges {
                node {
                    ...PrismicPricingTabsJsonFragment
                }
            }
        }
    }
`;

export const Pricing = ({ sliceContext, pageContext, location, slice }: PricingSliceProps) => {
    return (
        <StaticQuery
            // 'allPrismicPricingTabsJson' query is created by gatsy-transformer-json which used the data in the src/data
            query={`${PricingQuery}`}
            render={({
                allPrismicPricingTabsJson: pricingTabsData,
            }: {
                allPrismicPricingTabsJson: Edges<PricingTabDocument>;
            }) => {
                const { pricing_table, pricing_title } = slice.primary;
                const { tabs: pricingTabs, ...translations } = pricing_table;

                return (
                    <PricingProvider
                        env={process.env.GATSBY_ENV as Environment}
                        language={getTwoLetterLanguageCode(pageContext.lang) as Languages}
                        log={logger}
                    >
                        <StyledPricingContentBox>
                            <Heading as="h1" size="jb">
                                {pricing_title}
                            </Heading>
                            <PricingTabs
                                pricingTabs={pricingTabs}
                                pricingTabsData={pricingTabsData}
                                translations={translations}
                                sliceContext={sliceContext}
                                pageContext={pageContext}
                                location={location}
                            />
                        </StyledPricingContentBox>
                    </PricingProvider>
                );
            }}
        />
    );
};
